import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addorUpdatecoursePrice, addorUpdatePagecoursePrice, deletePagecoursePrice, loadCoursePrice } from "./CoursesPriceApi";

const initialState: any = {
  loading: {
    get:false,
    add:false,
    delete:false,
  },
  req_success: {
    get:false,
    add:false,
    delete:false
  },

  courses_price: [],
  single_course_price:[],
  single_page_course_price:[],
  showCoursePriceModal: false,
  showPageCoursePriceModal: false,
  
};

const CoursesPriceSlice = createSlice({
  name: "CoursesPrice",
  initialState,
  reducers: {
    singleCoursePrice:(state,{payload}:PayloadAction<any>)=>{
        state.single_course_price = state.courses_price.filter((item:any)=>item?.id === payload?.id);
        // state.showCoursePriceModal = true;

    },
    singlePageCoursePrice:(state,{payload}:PayloadAction<any>)=>{
        state.single_page_course_price = state.courses_price.filter((item:any)=>item?.id === payload?.id);
        // state.showCoursePriceModal = true;

    },
    setSinglePageCoursePrice:(state)=>{
        state.single_page_course_price = [];
        // state.showCoursePriceModal = true;

    },
    resetStates:(stats)=>{

    },
    setShowCoursePriceModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showCoursePriceModal = payload;
    },
    setShowPageCoursePriceModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showPageCoursePriceModal = payload;
    },
  },
  extraReducers: (builder) => {
    // LOAD COURSE PRICE
    builder.addCase(loadCoursePrice.pending, (state) => {
      state.loading.get = true;
      state.req_success.get = false;
      state.loading.add = false;
      state.req_success.add = false;
    });
    builder.addCase(
      loadCoursePrice.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get = false;
        state.req_success.get = true;
        state.loading.add = false;
        state.req_success.add = false;
        state.courses_price = payload?.data;
      }
    );
    builder.addCase(loadCoursePrice.rejected, (state) => {
      state.loading.get = false;
      state.req_success.get = false;
      state.loading.add = false;
      state.req_success.add = false;
    });

    // ADD OR UPDATE COURSES PRICE
    builder.addCase(addorUpdatecoursePrice.pending, (state) => {
      state.loading.add = true;
      state.req_success.add = false;
  
    });
    builder.addCase(
      addorUpdatecoursePrice.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add = false;
        state.req_success.add = true;
      
    
        // Find the index of the course to update
        const updatedCourseIndex = state.courses_price.findIndex(
          (course: any) => course.id === payload.price.id
        );
    
        // Update the course in the courses_price array
        if (updatedCourseIndex !== -1) {
          state.courses_price[updatedCourseIndex] = {
            ...state.courses_price[updatedCourseIndex],
            ...payload.price, // Update the specific fields
          };
        }
      }
    );
    
    builder.addCase(addorUpdatecoursePrice.rejected, (state) => {
      state.loading.add = false;
        state.req_success.add = false;
    
    });

    // ADD OR UPDATE Page COURSES PRICE
    builder.addCase(addorUpdatePagecoursePrice.pending, (state) => {
      state.loading.add = true;
        state.req_success.add = false;
 
    });
    builder.addCase(
      addorUpdatePagecoursePrice.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add = false;
        state.req_success.add = true;

        // console.log(payload);
      }
    );
    
    builder.addCase(addorUpdatePagecoursePrice.rejected, (state) => {
      state.loading.add = false;
        state.req_success.add = false;
     
    });
    // Delete
    builder.addCase(deletePagecoursePrice.pending, (state) => {
      state.loading.delete = true;
      state.req_success.delete = false;
    });
    builder.addCase(
      deletePagecoursePrice.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.delete = false;
        state.req_success.delete = true;

        // console.log(payload);
      }
    );
    
    builder.addCase(deletePagecoursePrice.rejected, (state) => {
      state.loading.delete = false;
      state.req_success.delete = false;
    });
  },
});

export const { setShowCoursePriceModal,singleCoursePrice,setShowPageCoursePriceModal,singlePageCoursePrice ,setSinglePageCoursePrice} = CoursesPriceSlice.actions;
export default CoursesPriceSlice.reducer;
